// extracted by mini-css-extract-plugin
export var assigneeBadge = "_ob-0";
export var assigneeDetails = "_ob-1";
export var assigneeInfo = "_ob-2";
export var dropdownContainer = "_ob-4";
export var dropdownImage = "_ob-5";
export var editAssigneeInfo = "_ob-3";
export var editAssigneeModalContainer = "_ob-6";
export var hidden = "_ob-8";
export var input = "_ob-7";